// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  envName: 'dev',
  endPoint: 'https://ene-dsiapisvc-001-d.azurewebsites.net',
  appInsights: {
    instrumentationKey: 'df181261-2316-4191-889c-f5836319f432'
  },
  adalConfig: {
    tenant: 'c1eb5112-7946-4c9d-bc57-40040cfe3a91',
    clientId: '37824aae-783f-40f7-8398-62c375895d65',
    navigateToLoginRequestUrl: false,
    postLogoutRedirectUri: window.location.origin + '/',
    isAngular: true,
    cacheLocation: 'sessionStorage'
  },
  userVoiceConfig: {
    apiKey: 'hcRvYu0ptNzRD4wlcplp9g',
    forumID: '923338'
  },
  defaultLanguage: 'en',
  supportedLanguages: [
    'en'
  ]
};



// WEBPACK FOOTER //
// D:/a/1/s/Fed/src/environments/environment.ts